import { render, staticRenderFns } from "./DesktopDrawer.vue?vue&type=template&id=36010474&scoped=true&"
import script from "./DesktopDrawer.vue?vue&type=script&lang=js&"
export * from "./DesktopDrawer.vue?vue&type=script&lang=js&"
import style0 from "./DesktopDrawer.vue?vue&type=style&index=0&id=36010474&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36010474",
  null
  
)

export default component.exports